import {
  enumItemSortOption,
  ItemSortOption,
} from '@rematter/frontend-lib-api-client';
import { DataGridSelection } from '@rematter/ui-web';
import { atom } from 'jotai';

import { itemDeleteAtom } from '../_graphql/mutationItemDelete';
import { itemsListQueryAtom } from '../_graphql/queryItemsList';
import { ItemRecord } from '../types/inventoryItem';

import { atomFromQueryString } from '~/shared/state';

// 🟣🟣🟣 PARAMS
export const $searchTerm = atomFromQueryString.string('q');
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);
export const $categoryFilter = atomFromQueryString.string('categoryId');
export const $itemGroupFilter = atomFromQueryString.string('itemGroupId');

// 🔘🔘🔘 PLAIN ATOMS
export const $selectedKeys = atom<DataGridSelection>(new Set<React.Key>());
export const $isCreateDialogOpen = atom<boolean>(false);
export const $selectedItem = atom<ItemRecord | null>(null);
export const $currentSorting = atom<ItemSortOption[]>([
  enumItemSortOption.NameAsc,
]);

// 🟢🟢🟢 REMOTE DATA
export const $remoteItems = itemsListQueryAtom((get) => {
  const searchTerm = get($searchTerm);
  const limit = get($limit);
  const offset = get($offset);
  const categoryId = get($categoryFilter);
  const itemGroupId = get($itemGroupFilter);
  const sorting = get($currentSorting);

  return {
    variables: {
      searchTerm: searchTerm || undefined,
      categoryId: categoryId || undefined,
      itemGroupId: itemGroupId || undefined,
      limit,
      offset,
      sorting,
    },
  };
});

// 🟠🟠🟠 ACTION -> DELETE item
export const $deleteItem = itemDeleteAtom({
  onSuccess: (get) => {
    get($remoteItems).refetch?.();
  },
});
